<template>
	<div class="container">
    <mt-header class="header" title="积分商城">
      <header-item slot="left" v-bind:isBack = true v-on:onclick="goBack">
      </header-item>    
    </mt-header> 
    <div class="list">
      <integral-product-list :items="hotProductList" title="热销商品" v-if="hotProductList && hotProductList.length > 0"></integral-product-list>

      <!-- 无限加载滚动列表 -->
      <div class="flex-wrapper" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <integral-product-list :items="productList" title="全部商品" v-if="productList && productList.length > 0"></integral-product-list>
        <div class="loading-wrapper">
          <p v-if='!isMore'>没有更多商品了</p>
          <mt-spinner type="triple-bounce" color='#FA800A' v-if='isMore'></mt-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HeaderItem } from '../../components/common'
import { Header, Indicator, Toast } from 'mint-ui';
import { productList } from '../../api/product';
import IntegralProductList from './child/IntegralProductList';

export default {
  name: 'integralMall',
  data() {
    return {
      params: {
        brand: this.$route.query.brand ? this.$route.query.brand : '',
        category: this.$route.query.category ? this.$route.query.category : '',
        shop: this.$route.query.shop ? this.$route.query.shop : '',
        is_exchange: 1,
        is_hot: 0,
        activity: null, // TODO: 确认activity的值
        sort_key: this.$route.query.sort_key ? this.$route.query.sort_key : 0,
        sort_value: 2,
        page: 1,
        per_page: 10,
      },
      productList: [], //商品列表
      hotProductList: [], //热销商品列表
      loading: false, //是否加载更多
      isMore: true //是否有更多
    };
  },
  components: {
    IntegralProductList,
  },
  mounted() {
  },
  created: function() {
    this.getHotProductList();
    this.getProductList(false);
  },
  computed: {
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    getHotProductList() {
      let data = this.params;
      productList(
        null,
        null,
        null,
        1,
        1,
        null,
        null,
        null,
        null,
        null,
      ).then(res => {
        this.hotProductList = res.products;
      });
    },

    /*
       * getProductList: 获取商品列表
       * @param：  ispush ？ true ：false 是否需要向商品列表追加数据
       */
    getProductList(ispush) {
      let data = this.params;
      productList(
        data.brand,
        data.category,
        data.shop,
        data.is_exchange,
        data.is_hot,
        data.activity,
        data.sort_key,
        data.sort_value,
        data.page,
        data.per_page
      ).then(res => {
        this.buildData(ispush, res);
      });
    },

    /*
       *  getList: 构建数据
       *  @param: ispush 是否改变向元数据追加数据
       *  @param: res 接口请求返回的数据
       */
    buildData(ispush, res) {
      if (res) {
        if (ispush) {
          this.productList = this.productList.concat(res.products);
        } else {
          this.productList = res.products;
        }
        this.isMore = res.paged.more == 1 ? true : false;
      }
    },

    getMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getProductList(true);
      }
    },

  }
};
</script>

<style lang="scss" scoped>
.container {
  height: auto;
  position: absolute;
  bottom: 0px;
  top: 0px;
  width: 100%;
}
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
.list {
  position: absolute;
  top: 44px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;

  .loading-wrapper {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 44px;
    p {
      color: #B0B0B0;
      font-size: 12px;
      font-weight: 'Regular';
      padding: 0px;
      margin: 0px;
    }
    span {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/integralmall/IntegralMall.vue